import { useEffect, useRef } from "react";
import React from "react";
import "../src/css/index.css";
import "primeicons/primeicons.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toast } from 'primereact/toast';
import Navbar from "./components/navBar";
import HomePage from "./pages/homePage";
import { PrimeReactProvider } from "primereact/api";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgetPassword from "./pages/ForgetPassword";
import NewPassword from "./pages/NewPassword";
import i18n from "./i18n";
import AddPay from "./pages/pay-check/addPay";
import AddCustomer from "./pages/pay-check/addCustomer";
import TestPage from "./pages/TestPage";
import CustomerList from "./pages/pay-check/CustomerList";
import PayList from "./pages/pay-check/PayList";
import { LoadingProvider } from "./components/Loading/LoadingProvider";
import WhatsAppProvider from "./utils/WhatsAppProvider";
import { ConfirmDialogProvider } from "./utils/ConfirmDialog/ConfirmDialogProvider";
import NoAuthPayList from "./pages/no-auth-pages/NoAuthPayList";
import NoAuthCustomerKVKKApprove from "./pages/no-auth-pages/NoAuthCustomerKVKKApprove";
import NoAuthGuarantorKVKKApprove from "./pages/no-auth-pages/NoAuthGuarantorKVKKApprove";
import Profile from "./pages/Profile";
import { AuthProvider, useAuth } from "./utils/AuthProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import Pricing from "./pages/pricing/Pricing";
import AdminPage from "./pages/AdminPage";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import toastService from "./utils/ToastService";
import LandingPage from "./pages/LandingPage";
import UserManualPage from "./pages/UserManualPage";

function AppContent() {
  const location = useLocation();
  const isNoAuthPage = location.pathname.includes('no-auth');
  const toast = useRef(null);
  const { user } = useAuth();


  useEffect(() => {
    toastService.setToast(toast);
  }, []);
  return (
    <>
      <Toast ref={toast} position="top-right" />
      <Routes>
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/no-auth/reset-password-confirm/:id" element={<ResetPasswordConfirm />} />
        <Route path="" element={user?.name ? <ProtectedRoute><Navbar item={<HomePage />} /></ProtectedRoute> : <LandingPage />} />
        <Route path="register" element={<Register />} />
        <Route path="login" element={<Login />} />
        <Route path="homepage" element={<ProtectedRoute><Navbar item={<HomePage />} /></ProtectedRoute>} />
        <Route path="add-pay" element={<ProtectedRoute><Navbar item={<AddPay />} /></ProtectedRoute>} />
        <Route path="customers" element={<ProtectedRoute><Navbar item={<CustomerList />} /></ProtectedRoute>} />
        <Route path="add-customer" element={<ProtectedRoute><Navbar item={<AddCustomer />} /></ProtectedRoute>} />
        <Route path="test" element={<ProtectedRoute><Navbar item={<TestPage />} /></ProtectedRoute>} />
        <Route path="pay-list" element={<ProtectedRoute><Navbar item={<PayList />} /></ProtectedRoute>} />
        <Route path="no-auth/pay-list/:id" element={<NoAuthPayList />} />
        <Route path="no-auth/customer-kvkk-approve/:id" element={<NoAuthCustomerKVKKApprove />} />
        <Route path="no-auth/guarantor-kvkk-approve/:id" element={<NoAuthGuarantorKVKKApprove />} />
        <Route path="/profile/:username" element={<ProtectedRoute><Navbar item={<Profile />} /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
        <Route path="/landing" element={<LandingPage />} />

        <Route path="pricing" element={user?.name ? <ProtectedRoute><Navbar item={<Pricing />} /></ProtectedRoute> : <Pricing />} />
        <Route path="user-manual" element={user?.name ? <ProtectedRoute><Navbar item={<UserManualPage />} /></ProtectedRoute> : <UserManualPage />} />

        <Route path="admins" element={<ProtectedRoute><Navbar item={<AdminPage />} /></ProtectedRoute>} />
      </Routes>
      {isNoAuthPage && <WhatsAppProvider phoneNumber="905325999867" />}
    </>
  );
}

export default function App() {
  document.addEventListener("DOMContentLoaded", () => {
    const savedLanguage = localStorage.getItem("language");
    const language = savedLanguage || "tr";
    i18n.changeLanguage(language);
  });

  useEffect(() => {
    const currentTheme = localStorage.getItem("theme");
    if (currentTheme) {
      document.documentElement.classList.add(currentTheme);
    }
  }, []);

  return (
    <React.StrictMode>
      <PrimeReactProvider>
        <LoadingProvider>
          <ConfirmDialogProvider>
            <BrowserRouter>
              <AuthProvider>
                <AppContent />
              </AuthProvider>
            </BrowserRouter>
          </ConfirmDialogProvider>
        </LoadingProvider>
      </PrimeReactProvider>
    </React.StrictMode>
  );
}